import $ from 'jquery';
import 'url-polyfill';

class AjaxPostsLoader {
  constructor(el) {
    this.$button = $(el);
    this.buttonHtml = this.$button.html();
    if (!this.$button.length) {
      return;
    }
    this.$target = $(this.$button.attr('href'));
    this.initOptions();
    this.queryParams = ['page', 'per_page', 'template'];
    this.busy = false;
    this.events();
    this.spinner = $('<div class="spinner-grow" role="status">\n' +
      '  <span class="sr-only">Loading...</span>\n' +
      '</div>');
  }

  initOptions() {
    this.options = {
      route: 'posts',
      page: 2,
      taxonomies: [],
      posts_per_page: 10,
    };

    this.options = Object.assign(this.options, this.$button.data());
  }

  events() {
    this.$button.click(e => {
      this.onClick(e);
    });
  }

  onClick(e) {
    e.preventDefault();
    this.getPosts();
  }

  getUrl() {
    let url = new URL(`${mild_vars.rest_base}/${this.options.route}`);
    this.queryParams.forEach(param => {
      if (typeof this.options[ param ] !== 'undefined') {
        url.searchParams.set(param, this.options[ param ]);
      }
    });

    Object.keys(this.options.taxonomies).forEach(taxonomy => {
      let terms = this.options.taxonomies[ taxonomy ];
      url.searchParams.set(taxonomy, terms.join(','));
    });

    return url.href;
  }

  getPosts() {
    let vm = this;
    this.setState('busy');
    $.ajax({
      url: vm.getUrl(),
      success: function(data, textStatus, request) {
        vm.appendPosts(data);
        if (vm.options.page === vm.options.totalPages) {
          vm.hideButton();
        }

        vm.options.page++;
      },
      complete: () => {
        this.setState('idle');
      },
    });
  }

  appendPosts(posts) {
    posts.forEach(post => {
      this.$target.append($(post.archive_template));
    });
  }

  hideButton() {
    this.$button.hide();
  }

  setState(state) {
    if (state === 'busy') {
      this.busy = true;
      this.$button.addClass('busy');
      this.$button.html(this.spinner);
    }
    else if (state === 'idle') {
      this.busy = false;
      this.$button.removeClass('busy');
      this.$button.html(this.buttonHtml);
    }
  }
}

export default AjaxPostsLoader;
